import React from 'react';
import Article from '../../components/article/Article';
import { blog01, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">
        A lot is happening, <br /> Check out these articles.
      </h1>
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupB">
        <a href="https://www.entrepreneur.com/article/431924">
          <div className="gpt3__blog-container_groupA">
            <Article
              imgUrl={blog01}
              date="June 22, 2022"
              text="Your Content Is Meaningless If This Important Element Is Missing"
            />
          </div>
        </a>
        <Article
          imgUrl={blog03}
          date="April 21, 2022"
          text="Should You Prioritize Traffic or Conversions on a New Website?"
        />
        <Article
          imgUrl={blog04}
          date="April 18, 2022"
          text="How to leverage social media the right way."
        />
        <Article
          imgUrl={blog05}
          date="March 11, 2022"
          text="What is SEO and how does it help you?"
        />
      </div>
    </div>
  </div>
);

export default Blog;
